import { z } from 'zod';
import {
  OptionsSchema as BaseOptionsSchema,
  AuiTokenSchema,
  TriggerUnionSchema,
  TriggerOptionSchema,
} from '../../WidgetVariant';

const SupportWindowHeaderSchema = z.union([
  z.object({
    alt: z.never().optional(),
    src: z.never().optional(),
    text: z.string(),
  }),
  z.object({
    alt: z.string().optional(),
    src: z.string(),
    text: z.never().optional(),
  }),
]);

const DisplayModesSchema = z.enum(['FAB', 'WINDOW', 'HIDDEN']);
export type DisplayModes = z.infer<typeof DisplayModesSchema>;
export const ShowActionDisplayModeSchema = DisplayModesSchema.exclude(['HIDDEN']);
export type ShowActionDisplayModes = z.infer<typeof ShowActionDisplayModeSchema>;

const FloatingActionButtonBaseSchema = z.object({
  callbackConfirmationImg: z
    .object({
      alt: z.string().optional(),
      src: z.string(),
    })
    .optional(),
  chatLogo: z
    .object({
      alt: z.string().optional(),
      src: z.string(),
    })
    .optional(),
  initialDisplayMode: DisplayModesSchema.optional(),
  chatPanelTextInputLabel: z.string().optional(),
  fabNotificationIndicatorColor: z.string().optional(),
  logo: z.object({
    alt: z.string().optional(),
    src: z.string(),
    lottieUrl: z.string().optional(),
  }),
  position: z
    .object({
      desktop: z
        .object({
          offsetBottomPx: z.number().min(1).optional(),
          offsetRightPx: z.number().min(1).optional(),
        })
        .optional(),
      mobile: z
        .object({
          offsetBottomPx: z.number().min(1).optional(),
          offsetRightPx: z.number().min(1).optional(),
        })
        .optional(),
    })
    .optional(),
  supportWindowHeader: SupportWindowHeaderSchema.optional(),
  size: z.enum(['small', 'medium', 'large']).optional(),
});

const FloatingActionButtonSchema = FloatingActionButtonBaseSchema.merge(AuiTokenSchema).merge(
  TriggerOptionSchema.partial()
);

export const OptionsSchema = BaseOptionsSchema.extend({
  'floating-action-button': TriggerUnionSchema.and(FloatingActionButtonSchema),
});

export const PartialOptionsSchema = BaseOptionsSchema.extend({
  'floating-action-button': TriggerUnionSchema.and(FloatingActionButtonSchema.partial()),
}).partial();

export type Options = z.infer<typeof OptionsSchema>;
export type PartialOptions = z.infer<typeof PartialOptionsSchema>;
